import { render, staticRenderFns } from "./TrafficMasterData.vue?vue&type=template&id=0e2cf3ce&scoped=true"
import script from "./TrafficMasterData.vue?vue&type=script&lang=js"
export * from "./TrafficMasterData.vue?vue&type=script&lang=js"
import style0 from "./TrafficMasterData.vue?vue&type=style&index=0&id=0e2cf3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2cf3ce",
  null
  
)

export default component.exports